// Region slug helpers — keep in sync with netlify/edge-functions/seo-meta.ts
// and scripts/generate-sitemap.mjs.

export function slugifyRegion(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[''ʻ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
